
import React, { useEffect, useRef, useState } from 'react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import axiosInstance from 'api/axiosInstance';
import logo4 from "../../../../assets/images/landing/logo4.png";
import config from "../../../../config.js";
import { useNavigate } from 'react-router-dom';

export default function ActiveBotsSlider() {
  const BASE_URL = config.cdnUrl;
  const [bots, setBots] = useState([]);
  const navigation = useNavigate()
  const swiperRef = useRef(null);
  useEffect(() => {
    const fetchBots = async () => {
      try {
        const res = await axiosInstance.get('business/@bots/list');
        if (res?.data?.ok) {
          setBots(res?.data?.data);
        }
      } catch (err) {
        console.error('Error fetching bots:', err);
      }
    };

    fetchBots();
  }, []);

  return (
    <div className="mx-[28px] sm:mx-[40px] ">
      <div>
        <h2 className="text-[#1f3e39] text-center font-bold text-4xl py-14">
          دستیارهای فعال
        </h2>
      </div>

      <Swiper 
       style={{margin:"auto"}}
        modules={[Navigation, Pagination, Autoplay]}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        slidesPerView={3}
        spaceBetween={30}
        loop={true}
        autoplay={{
          delay: 1000, // هر ۲.۵ ثانیه حرکت کنه
          disableOnInteraction: false, // وقتی کاربر با اسلایدر تعامل کرد، متوقف نشه
        }}
        speed={1000} // مدت زمان انیمیشن بین دو اسلاید (۱ ثانیه)
        onMouseEnter={() => swiperRef.current?.autoplay.stop()} // وقتی موس روشه، توقف کنه
        onMouseLeave={() => swiperRef.current?.autoplay.start()} // وقتی موس رفت، دوباره شروع کنه
        breakpoints={{
          0: { slidesPerView: 2 },
          640: { slidesPerView: 3 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 5 },
        }}
      >
        {bots.map((bot, index) => (
          <SwiperSlide key={bot.username || index}  onClick={() => navigation(`/${bot.username}`)}>
            <div className="flex flex-col items-center bg-white rounded-lg shadow-lg p-4 border-2">
              <img
                src={bot?.logo ? `${BASE_URL}${bot.logo}` : logo4}
                alt={bot.username}
                className="w-24 h-24 object-contain mb-3"
              />
              <p className="text-center text-gray-800 font-medium">
                {bot.username || "بدون نام"}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
